import { useNavigate } from 'react-router-dom';
import { useCreateMovie } from '@/hooks/useMovies';
import { CreateMovieRequest } from '@/types/model';
import MovieForm from '@/components/forms/MovieForm';
import { useTranslation } from '@/hooks';

const CreateMovie = () => {
  const navigate = useNavigate();
  const createMovieMutation = useCreateMovie();
  const { t } = useTranslation();

  const handleSuccess = async (data: CreateMovieRequest) => {
    try {
      await createMovieMutation.mutateAsync(data);
      navigate(-1);
    } catch (error) {
      console.error('Create movie error:', error);
      throw error;
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <button
            onClick={handleCancel}
            className="text-indigo-600 hover:text-indigo-500 text-sm font-medium mb-4 flex items-center"
          >
            ← {t.buttons.cancel}
          </button>
        </div>
        {/* Form */}
        <MovieForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          isSubmitting={createMovieMutation.isPending}
        />
      </div>
    </div>
  );
};

export default CreateMovie;
